import { setServices } from '@/http/clubsApi';
import { getCookie } from '@/utils/cookies';
import { getAppointmentServicesQuery } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useGetAppointmentServicesQuery = () => {
  const idClub = localStorage.getItem('id_club');
  const userToken = getCookie('user_token');
  return useQuery({
    queryKey: getAppointmentServicesQuery(),
    queryFn: () => setServices(idClub, userToken),
    select: (response) => response.data.data,
  });
};
